import * as React from "react";
import "./style.css";

/* eslint-disable import/no-webpack-loader-syntax */
import CloseIcon from "-!svg-react-loader!../../images/icn-close.svg";
import OpenNewWindowIcon from "-!svg-react-loader!../../images/icn-open-new-window.svg";
/* eslint-enable import/no-webpack-loader-syntax */

export interface ISideBarProps {
  isOpen: boolean;
  width: string;
  title: string;
  onClose: () => void;
  onOpen: () => void;
}

class SideBar extends React.Component<ISideBarProps, {}> {
  constructor(props: ISideBarProps) {
    super(props);

    this.state = { isOpen: false };
  }

  public render() {
    return (
      <div className="right-side-bar" style={{ width: this.props.isOpen ? this.props.width : "0px" }}>
        <div className="content" style={{ width: this.props.width }}>
          <div className="toolbar">
            <a className="icon-btn" onClick={e => this.props.onOpen()}>
              <OpenNewWindowIcon />
            </a>
            <span className="right-side-bar__title" title={this.props.title}>
              {this.props.title}
              <a id="close-preview-btn" className="icon-btn close-btn" onClick={e => this.props.onClose()}>
                <CloseIcon />
              </a>
            </span>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/report-preview-side-bar/index.tsx